const faq = [
    {
        question: 'ایا اپلیکشن دوبنده را در خارج از ایران میشه استفاده کرد؟  ',
        answer: 'بله و با استفاده از نسخه وب اپلیکیشن دوبنده امکان استفاده در هر دو پلتفرم اندروید و آی او اس وجود دارد.'
    },
    {
        question: 'کشتی را از چه سنی باید شروع کرد؟',
        answer: ' تا ۱۰ سالگی بهتر است ژیمناستیک کار شود و بعد از ان بنا به استعداد شخص  کشتی به صورت مفرح و کم فشار باشد'
    },
    {
        question: 'ایا ۲۰ سالگی برای شروع کشتی دیر است؟',
        answer: ' خیر  دیر نیست ، اگر فاکتورهای  استعداد، شرایط مالی  و مربی باعلم  مهیا باشد  در حدود ۴ سال به ایده ال میرسید'
    },
    {
        question: 'مصرف مکمل و استرویید ها مجاز هست؟',
        answer: 'مکمل در سنین بزرگسالان در کنار تغذیه خوب  کارایی مناسبی دارد'
    } ,
    {
        question : "ایا نوجوانان میتوانند مکمل مصرف کنند؟" ,
        answer : "  در سنین نونهالان و نوجوانان  مکمل مصرف نشود بهتر است و توجه اصلی به روی تغذیه صحیح باشد  چرا که آنزیم های احشام داخلی فرد به ایده ال نرسیدند"
    } ,
    {
        question : "نوجوانان و نونهالان میتونند وزن کم کنند؟" ,
        answer : "خیر  کاهش وزن در سنین رشد باعث اختلال در سیستم بدنی فرد میشود"
    } ,
    {
        question : "آیا هرچی بیشتر تمرین کنیم بیشتر پیشرفت میکنیم؟" ,
        answer : " خیر   سیکل امادگی بدن به طور کل در طول سال یکبار نهایت ۲ بار به پیک و اوج خود میرسد که با زمانبدی تمرینی  به اندازه و به موقع باید فشار وارد کنیم تا روز مسابقه در اوج امادگی باشیم"
    }
]

const about = "اپلیکیشن دوبنده  در سطح دنیا حرفی برای گفتن دارد.  اپلیکیشن آموزش کشتی دوبنده  شامل  ۴۰۰ کلیپ علم کشتی و  تکنیک های آموزش کشتی به صورت دسته بندی و تفکیک شده  و هر آنچه که یک کشتی گیر نیاز دارد در خود جای داده است و ما قصد داریم برای ارتقای کشتی کشور از قهرمانان و پیشکسوتان در آینده بهره بگیریم. تا بتوانیم به کمک علم روز تمرین باعث پیشرفت کشتی گیران بشویم ."

const contactUs = {
    mobile: '09381100900',
    email: 'amozeshkoshti2020@gmail.com'
}
export {
    faq,
    about,
    contactUs
}